import apiService from "@services/apiService";

class SystemAnnouncementService {
  static create() {
    return new SystemAnnouncementService();
  }

  async getActive() {
    const response = await apiService.get(`system_announcements/active`);
    return response.data;
  }
}

export default SystemAnnouncementService;
